import React from "react";
import { FormattedMessage } from "react-intl";
import CustomChip from "../general/chips";

const CostForm = () => {

  const labelChips = ["Marca da bollo", "Commissioni bonifico", "Altro"];
  let chips = [];

  for (let item in labelChips) {
    if (item){
      chips.push(<CustomChip
        key={"spesa_" + item}
        closable="false"
        onClose={() => {}}
        style={{
          marginTop: "10px",
          width: "max-content",
          maxWidth: 400,
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          overflow: "hidden",
          backgroundColor: "#d8d8d9",
          borderColor: "#d8d8d9",
          color: "#5a6872"
        }}
        description={labelChips[item]}
      />);
    }
  }

  return (
    <div style={{minHeight:"480px"}}>
      <div className="reconciliation-subtitle">
        <FormattedMessage id="reconciliation.deadlines.cost" />
      </div>
      <div style={{fontSize:"16px", marginTop:"10px", marginBottom: "10px"}}>
        <FormattedMessage id="reconciliation.deadlines.residueCost" />
      </div>
      <div style={{display: "flex"}}>
        {chips}
      </div>
    </div>
  );
};

export default CostForm;
